// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__CaP1V","content":"footer_content__oSn80","logo":"footer_logo__4Cgy-","logoIcon":"footer_logoIcon__YjjlX","text":"footer_text__r1vNW"};